import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { merge } from 'lodash/fp';

import { getAvailabilityHash } from '../../utils/getAvailabilityHash';
import { BOOKING_RESTARTED } from '../global/actionTypes';
import { OTHER_DATES_SUGGESTED } from '../otherDatesSuggestions/actionTypes';
import { OtherDatesSuggestedPayload } from '../otherDatesSuggestions/types';
import { fetchServicePricingSucceeded } from '../servicePricing/reducers';

import { AvailableCategories } from './types';

const initialState: AvailableCategories = {};

const availableCategoriesSlice = createSlice({
    name: 'availableCategories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchServicePricingSucceeded,
            (state, { payload: { availabilityHash, categoryPrices, violatedRestrictions } }) =>
                merge(state, {
                    [availabilityHash]: {
                        availableCategoryIds: categoryPrices.map(({ categoryId }) => categoryId),
                        violatedRestrictionIds: violatedRestrictions.map(({ id }) => id),
                    },
                })
        );
        builder.addCase(
            OTHER_DATES_SUGGESTED,
            (
                state,
                {
                    payload: { availabilityHash, suggestions, enterpriseId, voucherCode },
                }: PayloadAction<OtherDatesSuggestedPayload, typeof OTHER_DATES_SUGGESTED>
            ) => {
                const availableCategory = state[availabilityHash] ?? {
                    violatedRestrictionIds: [],
                    availableCategoryIds: [],
                };
                availableCategory.suggestions = suggestions.map((suggestion) => ({
                    ...suggestion,
                    availabilityId: getAvailabilityHash({
                        startDate: suggestion.startDate,
                        endDate: suggestion.endDate,
                        enterpriseId,
                        voucherCode,
                    }),
                }));
                state[availabilityHash] = availableCategory;
            }
        );
        builder.addCase(BOOKING_RESTARTED, () => initialState);
    },
});

export const availableCategoriesReducer = availableCategoriesSlice.reducer;
